import _ from 'lodash';

export const AB_TEST_DOCS = {
    TEACHER_DASHBOARD_10: {
        name: 'teacherDashboard10',
        init: false,
        inCode: true,
        desc: 'Used in game creation. TD10-TD12 considered `new`.',
    },
    TEACHER_DASHBOARD_11: {
        name: 'teacherDashboard11',
        init: false,
        inCode: true,
        desc: 'Used in game creation. TD10-TD12 considered `new`.',
    },
    TEACHER_DASHBOARD_12: {
        name: 'teacherDashboard12',
        init: false,
        inCode: true,
        desc: 'Used in game creation. TD10-TD12 considered `new`.',
    },
    NO_ENERGY: {
        name: 'noEnergy',
        init: true,
        inCode: true,
        desc: 'Experiment with Group 5 students, if not participant of Masters League, remove energy.',
    },
    SPECIAL_ENERGY_OFFER: {
        name: 'specialEnergyOffer',
        init: false,
        inCode: true,
        desc: 'Infinity energy for subscribed students. 1293945 users has "yes" as of 13.06.2025',
    },
};

export const AB_TESTS = _.mapValues(AB_TEST_DOCS, 'name');
